import buttonRadar from '../shared/button-radar.vue'

var slideshow;

export default  {

    name: 'screensaver',

    components: {buttonRadar},

    data() {
       return{
           slides: this.$store.state.product.images[this.$route.params.product].slides
       }
    },


    computed:{

        productTitle: function(){
            return this.$store.state.product.title;
        },

        productModel: function(){
            return this.$store.state.product.model;
        },

        productPrice: function(){
            return this.$store.state.product.price;
        },

        productPricePromo: function(){
            return this.$store.state.product.promo;
        }

    },


    mounted(){

        let app = document.getElementById("app");
        app.style.backgroundImage = "";

        this.startSlideshow();

    },


    beforeDestroy(){

        //Stop the slideshow when navigate off
        this.stopSlideshow(slideshow)
    },


    methods:{

        // Stop Slideshow
        stopSlideshow(slideshow){

            // if interval exists
            if(slideshow){
                // clear it
                clearInterval(slideshow);
            }

        },

        // Start Slideshow
        startSlideshow(){

            const vm = this;
            let screensaver = document.getElementById("screensaver");

            let i = 0;

            // Create Slideshow
            slideshow = setInterval(function () {

                // loop for each slide in the store and set it as the Screensaver Background Image
                screensaver.style.backgroundImage = "url(" + vm.slides[i] + ")";

                if(i < vm.slides.length - 1){
                    i++;
                }else{
                    i = 0;
                }

            }, 6000);


        }

    }

}




// WEBPACK FOOTER //
// ./src/components/screensaver/screensaver.component.js